// Shared formatters for training duration and distance.
// Duration is stored in minutes; distance is stored in miles (TrainingPeaks native).

export function fmtDuration(min) {
  const m = Math.round(Number(min) || 0);
  if (!m) return "—";
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (!h) return `${mm}m`;
  return mm ? `${h}h ${mm}m` : `${h}h`;
}

const KM_PER_MI = 1.609344;

// Distance is always saved in miles. Convert to km when the athlete uses metric.
// Returns "" when there's nothing meaningful to show.
export function fmtDistanceFromMi(mi, system) {
  const v = Number(mi);
  if (!v || isNaN(v)) return "";
  if (system === "imperial") {
    const s = v.toFixed(v >= 10 ? 0 : 1).replace(/\.0$/, "");
    return `${s} mi`;
  }
  const km = v * KM_PER_MI;
  const s = km.toFixed(km >= 10 ? 0 : 1).replace(/\.0$/, "");
  return `${s} km`;
}

export const distanceUnitLabel = (system) => (system === "imperial" ? "mi" : "km");
